import { FagmoblerAlgoliaProduct } from '@fagmobler/types';
import { ProductJsonLd } from 'next-seo';
import { ServerProduct } from '@/lib/janitsjar/Product';

export const ProductPageJsonLd = ({
  algoliaProduct,
  product,
  canonicalUrl,
}: {
  algoliaProduct?: FagmoblerAlgoliaProduct;
  product?: ServerProduct;
  canonicalUrl: string;
}) => {
  if (!algoliaProduct || !product) return null;
  const {
    objectID,
    posterName,
    posterDescription,
    supplier,
    colour,
    material,
    price,
    campaignPrice,
  } = algoliaProduct;

  const { media } = product;

  if (!posterName) return null;
  const pickedPrice = campaignPrice || price;
  return (
    <ProductJsonLd
      useAppDir={true}
      productName={posterName}
      description={posterDescription}
      images={
        (media?.map((asset) => asset.url).filter(Boolean) as string[]) ||
        undefined
      }
      brand={supplier}
      color={colour}
      material={material}
      sku={objectID}
      // Consider adding all stores with stock status
      offers={[
        {
          price: pickedPrice ? pickedPrice : undefined,
          highPrice: price ? price : undefined,
          lowPrice: campaignPrice ? campaignPrice : undefined,
          priceCurrency: 'NOK',
          url: canonicalUrl,
          itemCondition: 'https://schema.org/NewCondition',
        },
      ]}
    />
  );
};
